import { styled } from '@mui/material/styles';
import { IconButton, TextField, Box, Button, Paper } from '@mui/material';

export const DialogTitleStyled = styled('div')(({ theme }) => ({
  fontWeight: 550,
  fontSize: '1.5rem',
  color: '#1a1a1a',
  textAlign: 'center',
  padding: '16px 24px',
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  marginLeft: '3px',
}));

export const CloseIconButtonStyled = styled(IconButton)(({ theme }) => ({
  color: '#808080',
  fontSize: '1.5rem',
}));

export const StyledTextField = styled(TextField)(({ theme }) => ({
  marginTop: theme.spacing(1),
  marginBottom: theme.spacing(1),
  backgroundColor: '#fff',
  borderRadius: '12px',
  boxShadow: '0px 2px 8px rgba(0,0,0,0.06)',
  '& .MuiOutlinedInput-root': {
    borderRadius: '10px',
    '& fieldset': {
      border: '1.5px solid #e3e3e3',
    },
    '&:hover fieldset': {
      border: '1.5px solid #1976d2',
    },
    '&.Mui-focused fieldset': {
      border: '2px solid #1976d2',
    },
  },
}));

export const InProgressListWrapper = styled(Box)(({ theme }) => ({
  marginTop: theme.spacing(3)
}));

export const InProgressListTitle = styled('div')(({ theme }) => ({
  fontWeight: 600,
  fontSize: '1.07rem',
  marginBottom: theme.spacing(1),
  color: '#212121'
}));

export const ButtonGroupBox = styled(Box)(({ theme }) => ({
  display: 'flex',
  gap: theme.spacing(1.2),
  [theme.breakpoints.down('sm')]: {
    flexDirection: 'column',
    alignItems: 'stretch',
    marginTop: theme.spacing(0.8),
    gap: theme.spacing(1),
    width: '100%',
  },
}));

export const BlueContainedButton = styled(Button)(({ theme }) => ({
  background: '#0084ff',
  color: '#fff',
  fontWeight: 550,
  borderRadius: '6px',
  letterSpacing: '0.04em',
  boxShadow: 'none',
  textTransform: 'uppercase',
  fontSize: '0.97em',
  minWidth: 100,
  whiteSpace: 'nowrap',
  paddingLeft: 18,
  paddingRight: 18,
  [theme.breakpoints.down('sm')]: {
    width: '100%',
    minWidth: 0,
    paddingLeft: 0,
    paddingRight: 0,
  },
  '&:hover': {
    background: '#0066cc',
  },
}));

export const RedContainedButton = styled(Button)(({ theme }) => ({
  background: '#f44336',
  color: '#fff',
  fontWeight: 550,
  borderRadius: '6px',
  letterSpacing: '0.04em',
  boxShadow: 'none',
  textTransform: 'uppercase',
  fontSize: '0.97em',
  minWidth: 100,
  whiteSpace: 'nowrap',
  paddingLeft: 18,
  paddingRight: 18,
  [theme.breakpoints.down('sm')]: {
    width: '100%',
    minWidth: 0,
    paddingLeft: 0,
    paddingRight: 0,
  },
  '&:hover': {
    background: '#c62828',
  },
}));

export const StyledListItemCard = styled(Paper)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  padding: '10px 12px',
  marginBottom: theme.spacing(1.2),
  borderRadius: 14,
  background: '#f7faff',
  boxShadow: '0 2px 8px 0 rgba(0,0,0,0.04)',
  [theme.breakpoints.down('sm')]: {
    flexDirection: 'column',
    alignItems: 'stretch',
    padding: '10px 8px',
    gap: 4,
  }
}));

export const StyledListItemTextBox = styled(Box)(({ theme }) => ({
  flex: 1,
  display: 'flex',
  flexDirection: 'column',
  gap: 2,
  [theme.breakpoints.down('sm')]: {
    marginBottom: theme.spacing(1),
  }
}));

export const ReassignActionBox = styled(Box)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  gap: theme.spacing(1.5),
  padding: `${theme.spacing(1.5)} ${theme.spacing(2)}`,
  backgroundColor: "#f8f9fa",
  borderRadius: "12px",
  border: "1px solid #e0e0e0",
  marginTop: "-6px",
  [theme.breakpoints.down('sm')]: {
    flexDirection: 'column',
    alignItems: "stretch",
    gap: theme.spacing(1),
    padding: theme.spacing(1),
  },
}));

export const ReassignSmallButton = styled(Button)(({ theme }) => ({
  flex: 1,
  minWidth: 90,
  fontSize: '0.93em',
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  [theme.breakpoints.down('sm')]: {
    fontSize: '0.97em',
    width: '100%',
    minWidth: 0,
  },
}));